// What handleError runs when no configured policy applies: matches everything, never skips the default notification,
// and has no postProcess — so an unmatched error is just logged and notified.
export const defaultPolicy = {
    appliesTo: () => true,
};
